import {Transcriber} from './transcriber.js';

export class TranscriberTitle extends Transcriber {
	constructor(component_key) {
		super(component_key);
		this.tracking_section = 'title';
	}

	init() {
		super.init();
		if (!this.is_supported() || !this._language_matches()) {
			this.$root.remove();
			return;
		}
		this.$input = jQuery('.js-mpaf_title_input');
		this.$start_btn = this.$root.find('.js-transcriber_start');
		this.$stop_btn = this.$root.find('.js-transcriber_stop');
		this.$mic = this.$root.find('.js-transcriber_mic');
		this.$start_btn.on('click', () => this.start_dictation());
		this.$stop_btn.on('click', () => this.stop_dictation());
		this.$mic.on('click', () => {
			this.is_recording ? this.stop_dictation() : this.start_dictation();
		});
		this._bind_cursor_tracking(this.$input);
	}

	get_selection_start() {
		return this.$input[0].selectionStart || 0;
	}

	get_selection_end() {
		return this.$input[0].selectionEnd || 0;
	}

	set_cursor_position(pos) {
		const el = this.$input[0];
		el.selectionStart = el.selectionEnd = pos;
	}

	get_textarea_value() {
		return this.$input.val();
	}

	set_textarea_value(val) {
		this.setting_value = true;
		this.$input.val(val).trigger('input');
		this.setting_value = false;
	}

	get_max_length() {
		return parseInt(this.$input.attr("maxlength")) || 0;
	}

	focus_textarea() {
		this.$input.focus();
	}
}

